import { bfsSsoHttp, bfsUserWebHttp, otmsHttp } from '../../../../utils/http/index'

/**
 * 用户名+密码登录
 * https://yapi.ops.yunlizhi.cn/project/18/interface/api/217
 */
export function login(data) {
  return bfsSsoHttp.post('/login_by_password', data)
}

/**
 * 切换组织重新登录
 * https://yapi.ops.yunlizhi.cn/project/18/interface/api/1801
 */
export function resetLogin(data) {
  return bfsUserWebHttp.post('/bfs-sso/login_by_server', data)
}

/**
 * 查询货主详情信息
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/8540
 */
export function sessionDetail(data) {
  return bfsUserWebHttp.post('/customer/user/detail', data)
}

/**
 * 修改货主登录密码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9344
 */
export function modifyPassword(data) {
  return bfsUserWebHttp.post('/bfs_user/customer_account/password/modify', data)
}

/**
 * 获取图片验证码(找回密码专用)
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9346
 */
export function Forgetimg(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/pic_captcha', data)
}

/**
 * 校验图形验证码，并发送手机验证码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9348
 */
export function ForgetCode(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/send_sms_captcha', data)
}

/**
 * 找回密码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9350
 */
export function ForgetPassword(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/retrieve_password', data)
}

/**
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/18769
 * 配置中心
 */
export function getRosterPage(data) {
  return otmsHttp.post('/config_center/list', data)
}

/**
 * 货主账号通用获取图片验证码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9586
 */

export function getPicCaptcha(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/new_pic_captcha', data)
}

/**
 * 校验图形验证码，并发送手机验证码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9348
 */
export function getSmsCaptcha(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/send_sms_captcha', data)
}

/**
 * 货主账号注册（只注册账号，不关联货主）
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/14200
 */

 export function accountRegister(data) {
  return bfsUserWebHttp.post('/bfs-user/customer_account/register', data)
}

/**
 * 不需要登录查询货主信息
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/17989
 */
export function getUserName(data) {
  return otmsHttp.post('/customer/fetch_by_mobile', data)
}

/**
 * 获取企业货主所以下级租户货主
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/17971
 */
 export function organizationCorpCustomerList(data) {
  return bfsUserWebHttp.post('/bfs-user/account_org/organization/corp_customer_list', data)
}